export default function WhySpeed() {
  const insights = [
    {
      icon: 'ri-user-search-line',
      title: 'Most homeowners contact multiple builders',
      description:
        'Homeowners typically reach out to more than one extension company. Responding quickly increases the chance of being the builder they speak to first.',
    },
    {
      icon: 'ri-timer-line',
      title: 'Enquiries go cold quickly',
      description: `If enquiries aren't handled promptly, homeowners move on. Speed is often the difference between booking a conversation and losing the opportunity.`,
    },
    {
      icon: 'ri-coins-line',
      title: 'Every missed enquiry is costly',
      description:
        'With projects worth thousands, missed calls and delayed follow-ups often mean lost jobs — not just lost leads.',
    },
  ];

  return (
    <section className="py-20 px-6 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-[#1a2947] mb-6">
            Why <span className="text-[#2B5797]">Speed</span> Matters
          </h2>
          <p className="text-xl text-[#334155] max-w-3xl mx-auto leading-relaxed">
            In the competitive world of house extensions and loft conversions, the first builder to respond often wins the job. Here's why:
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {insights.map((insight, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 text-center shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-[#4A6FA5] rounded-full mx-auto mb-6 shadow-md">
                <i className={`${insight.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-3xl font-bold text-[#334155] mb-4 max-w-xs mx-auto leading-tight">{insight.title}</div>
              <p className="text-lg text-[#334155]/70 leading-relaxed">{insight.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}